export interface TeamMember {
  id: string;
  teamId: string;
  userId: string;
  userName: string;
  userAvatarUrl?: string;
  joinedAt: Date;
}
